import Carousel from "@components/Carousel";
import StrapiImage from "@components/StrapiImage";
import { useWindowSize } from "@justhome/common/hooks";
import { Title } from "@justhome/react-ui";
import {
  ComponentSectionsImageCarousel,
  UploadFileRelationResponseCollection,
} from "@lib/generated/graphql";
import { FC, useMemo } from "react";

type ImageCarouselProps = {
  data: ComponentSectionsImageCarousel;
};

const ImagesCarousel: FC<{
  images?: UploadFileRelationResponseCollection;
}> = ({ images }) => {
  const { width } = useWindowSize();

  const items = useMemo(() => {
    return images?.data.map((image, index) => (
      <div
        className="relative mr-s s:mr-3s pb-[55%] rounded-m overflow-hidden"
        key={index}
      >
        <StrapiImage
          alt=""
          fill
          className="object-cover"
          image={{ data: image }}
        />
      </div>
    ));
  }, [images]);

  if (!items) {
    return null;
  }

  const responsive = {
    0: { items: 1 },
  };

  const padding = width && width > 960 ? 200 : 8;

  return (
    <div className="w-full relative">
      <Carousel
        paddingLeft={padding}
        paddingRight={padding} // This helps display the third item as a preview ("there are more ...")
        responsive={responsive}
        disableDotsControls
        disableButtonsControls
        mouseTracking
        items={items}
      />
    </div>
  );
};
const ImageCarousel: FC<ImageCarouselProps> = ({ data }) => {
  if (!data) {
    return null;
  }
  return (
    <section className="overflow-hidden my-3xl m:my-[160px] rounded-m">
      <div className="px-s m:p-3lx mb-m s:mb-xl">
        {data.title && (
          <div className="m-auto text-center">
            <Title>{data.title}</Title>
          </div>
        )}
        {data.subTitle && (
          <h3 className="text-body-1 mt-3s font-normal text-center">
            {data.subTitle}
          </h3>
        )}
      </div>

      <ImagesCarousel images={data.images} />
    </section>
  );
};

export default ImageCarousel;
